import { useStaticQuery } from "gatsby";
export const useSeo = () => {
    return useStaticQuery("1132069882");
};
